<span
    *ngIf="hasTextReference"
    class="material-symbols-rounded pdf-reference-icon"
    [appTooltip]="sourceText"
    aria-hidden="true"
    (click)="onClick()"
    role="button"
    tabindex="0"
>
    document_search
</span>
